import "../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeProps as _mergeProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("corporate-footer__footermobileinfo-0ms17q", {
  maxWidth: "250px",
  marginBottom: "32px",
  "@media (min-width: 1024px)": {
    display: "none"
  }
});
const _staticStyles2 = _cssRef("corporate-footer__searchbarwrapper-1fp640", {
  maxWidth: "325px",
  marginBottom: "48px",
  fontSize: "18px",
  lineHeight: "28px",
  "@media (min-width: 1024px)": {
    display: "none",
    paddingRight: "0"
  }
});
import React from 'react';
import SiteSearch from '../site-search/site-search';
const corporateFooterStyles = {
  footerMobileInfo: _staticStyles,
  searchbarWrapper: _staticStyles2
};
interface CorporateFooterProps {
  links?: Array<{
    title?: string | null;
    links?: Array<{
      title?: string | null;
      url?: string | null;
      className?: string | null;
      sublinks?: Array<{
        title?: string | null;
        url?: string | null;
        className?: string | null;
        sublinks?: Array<{
          title?: string | null;
          url?: string | null;
        }>;
      }>;
    }> | null;
  }> | null;
  staticDisclaimerCopy?: string | null;
  dynamicFooterDisclaimers?: ReadonlyArray<{
    contentBefore?: string | null;
    content?: string | null;
    pageMatch?: string | null;
  }>;
  currentPath?: string;
}
const CorporateFooter: React.FC<CorporateFooterProps> = () => <>
        <div {..._mergeProps({
    css: corporateFooterStyles.footerMobileInfo
  })}>
            801 Industrial Blvd
            <br />
            Gallatin, TN 37066
            <br />
        </div>
        <div {..._mergeProps({
    css: corporateFooterStyles.searchbarWrapper
  })}>
            <SiteSearch />
        </div>
    </>;
export default CorporateFooter;